<!-- bbs > 보고서 -->
<template>
  <div class="tabCont">
    <div class="content-inner-box">
      <div class="tit-group ty01 mo-home-add">
        <BtnIcon class="btn-ico-home" @click="utils.movePage('/actionManagement')"></BtnIcon>
        <h4 class="tit">{{monitoringInfo.monitoringTitle}}</h4>
        <c-btnLine01 :btnText="t('message.validateData')" class="sm ty03" @click="reportValidationDialogModel=true" v-if="user.roles != 'USER'"/>
      </div>
      <div class="tit-group02 inner-ty">
        <h2 class="tit"></h2>
        <div class="filter-btn-group">
          <v-btn class="reset" :class="filterDiv1" @click="onClickInitFilter">{{t('message.filterInit')}}</v-btn>
          <v-btn class="filter" @click="filterOpen1" :class="filterDiv1">{{t('message.filter')}}</v-btn>
        </div>
      </div>
      <div class="sort-group ty01" :class="filterDiv1">
        <div class="sort-row">
          <div class="wl">
            <div class="date-sort">
              <c-InputDate v-model="startDate" :enableTimePicker="false" readonly="" />
              <div class="txt02">~</div>
              <c-InputDate v-model="endDate" :enableTimePicker="false" readonly=""/>
            </div>
            <div class="date-sort">
              <c-btn02 :btnText="t('message.currentMonth')" class="ty01" @click="onClickDate('month')"/>
              <c-btn02 :btnText="t('message.quarter')" class="ty01" @click="onClickDate('quarter')"/>
              <c-btn02 :btnText="t('message.year2')" class="ty01" @click="onClickDate('year')"/>
            </div>
          </div>
        </div>
        <div class="sort-row">
          <div class="wl">
            <Select v-bind="memberSelect" v-model="memberModel"/>
            <Select v-bind="deptSelect" v-model="deptModel"/>
            <Select v-bind="posSelect" v-model="posModel"/>
            <Select v-bind="shiftSelect" v-model="shiftModel"/>
            <Select v-bind="monitoringSelect" v-model="monitoringModel"/>
          </div>
        </div>
      </div>
    </div>
    <!--row-->
    <div class="tit-group02 ty02 mo-ty02">
      <h2 class="tit">{{t('message.simpleReport')}}</h2>
    </div>
    <div class="content-inner-box ty01">
      <div class="tit-group ty01">
        <h4 class="tit">{{t('message.quickKPI')}}</h4>
      </div>
      <div class="card-group02 ty02">
        <!--card-item-->
        <div class="card-col-wrap" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryFrequency=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryFrequency"
                        @click.stop="onClickUpdateDisplay('summaryFrequency',reportDisplayInfo.summaryFrequency)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ allAnswerCnt }}</div>
              </div>
              <div class="txt2">{{t('message.participationFrequency')}}</div>
            </div>
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ periodAnswerCnt }}</div>
              </div>
              <div class="txt2">{{t('message.goalAchievement')}}</div>
            </div>
          </div>
        </div>
        <!--card-item-->
        <div class="card-col-wrap" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryRate=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryRate"
                        @click.stop="onClickUpdateDisplay('summaryRate',reportDisplayInfo.summaryRate)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ allAnswerPercent }}<span>%</span></div>
              </div>
              <div class="txt2">{{t('message.participationRate')}}<span class="sub-txt">{{`(${allAnswerCnt}/${allPeriodCnt})`}}</span></div>
            </div>
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ periodAnswerPercent }}<span>%</span></div>
              </div>
              <div class="txt2">{{t('message.goalAchievementRate')}}<span class="sub-txt">{{`(${periodAnswerCnt}/${allPeriodCnt})`}}</span></div>
            </div>
          </div>
        </div>
        <!--card-item-->
        <div class="card-col-wrap" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineRate=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryTimelineRate"
                        @click.stop="onClickUpdateDisplay('summaryTimelineRate',reportDisplayInfo.summaryTimelineRate)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ timelineTy1CompleteCnt }}</div>
              </div>
              <div class="txt2">{{t('message.correctiveActionCompleted')}}</div>
            </div>
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ timelineTy1Percent }}<span>%</span></div>
              </div>
              <div class="txt2">{{t('message.correctiveActionCompletionRate')}}<span class="sub-txt">{{`(${timelineTy1CompleteCnt}/${timelineTy1Cnt})`}}</span></div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-group02 ty02 c-ty01">
        <!--card-item-->
        <div class="card-col-wrap ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineAll=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryTimelineAll"
                        @click.stop="onClickUpdateDisplay('summaryTimelineAll',reportDisplayInfo.summaryTimelineAll)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ timelineAllRate }}<span>%</span></div>
              </div>
              <div class="txt2">{{t('message.safetyTalkParticipationRate')}}<span class="sub-txt">{{`(${timelineAllAnswerCnt}/${allAnswerCnt})`}}</span></div>
            </div>
          </div>
        </div>
        <!--card-item-->
        <div class="card-col-wrap ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineType1=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryTimelineType1"
                        @click.stop="onClickUpdateDisplay('summaryTimelineType1',reportDisplayInfo.summaryTimelineType1)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ timelineTy1Rate }}<span>%</span></div>
              </div>
              <div class="txt2">{{t('message.correctiveFeedbackImplementationRate')}}<span class="sub-txt">{{`(${timelineTy1AnswerCnt}/${allAnswerCnt})`}}</span></div>
            </div>
          </div>
        </div>
        <!--card-item-->
        <div class="card-col-wrap ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineType2=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryTimelineType2"
                        @click.stop="onClickUpdateDisplay('summaryTimelineType2',reportDisplayInfo.summaryTimelineType2)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ timelineTy2Rate }}<span>%</span></div>
              </div>
              <div class="txt2">{{t('message.supportiveFeedbackImplementationRate')}}<span class="sub-txt">{{`(${timelineTy2AnswerCnt}/${allAnswerCnt})`}}</span></div>
            </div>
          </div>
        </div>
        <!--card-item-->
        <div class="card-col-wrap ty02" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryTimelineReceive=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryTimelineReceive"
                        @click.stop="onClickUpdateDisplay('summaryTimelineReceive',reportDisplayInfo.summaryTimelineReceive)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="card-col ty05">
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ myTimelineTy1Cnt }}</div>
              </div>
              <div class="txt2">{{t('message.correctiveFeedbackReceived')}}</div>
            </div>
            <div class="txt-group">
              <div class="inner">
                <div class="txt1">{{ myTimelineTy2Cnt }}</div>
              </div>
              <div class="txt2">{{t('message.supportiveFeedbackReceived')}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="card-group02 ty03">
        <div class="card-col" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryMemberTop=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryMemberTop"
                        @click.stop="onClickUpdateDisplay('summaryMemberTop',reportDisplayInfo.summaryMemberTop)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="tit">
            {{t('message.activityLeaderOfTheMonth')}}
            <c-tooltip :TooltipText="t('message.currentMonthTopPerformerLabel')"/>

          </div>
          <v-carousel v-if="memberAnswerListReverse.length > 0"
            hide-delimiters
            height="auto"
            :continuous="false"
          >
            <v-carousel-item
              v-for="(item, i) in memberAnswerListReverse"
              :key="'memberAnswerList_'+item.idx"
            >
              <div class="txt1">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
              <div class="txt2">
                <span>{{t('message.monitoring')}} <span>{{ item.allAnswerCnt }}{{t('message.countUnit')}}</span></span>
                <span>{{t('message.safetyTalk')}} <span>{{ item.timelineTy1Cnt + item.timelineTy2Cnt }}{{t('message.countUnit')}}</span></span>
              </div>
            </v-carousel-item>
          </v-carousel>
        </div>
        <div class="card-col" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.summaryMemberBottom=='Y')">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.summaryMemberBottom"
                        @click.stop="onClickUpdateDisplay('summaryMemberBottom',reportDisplayInfo.summaryMemberBottom)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <div class="tit">
            {{t('message.activityLaggardOfTheMonth')}}
            <c-tooltip :TooltipText="t('message.currentMonthLowPerformerLabel')"/>

          </div>
          <v-carousel v-if="memberAnswerList.length > 0"
            hide-delimiters
            height="auto"
            :continuous="false"
          >
            <v-carousel-item
              v-for="(item, i) in memberAnswerList"
              :key="'memberAnswerListReverse_'+item.idx"
            >
              <div class="txt1">{{ item.memberName?item.memberName:t('message.noInfo') }} / {{ item.deptName?item.deptName:t('message.noInfo') }} / {{ item.posName?item.posName:t('message.noInfo') }}</div>
              <div class="txt2">
                <span>{{t('message.monitoring')}} <span>{{ item.allAnswerCnt }}{{t('message.countUnit')}}</span></span>
                <span>{{t('message.safetyTalk')}} <span>{{ item.timelineTy1Cnt + item.timelineTy2Cnt }}{{t('message.countUnit')}}</span></span>
              </div>
            </v-carousel-item>
          </v-carousel>
        </div>
      </div>
    </div>
    <!--row-->
    <div class="content-inner-box ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineFrequencyRate=='Y')">
      <div class="tit-group ty01">
        <h4 class="tit">{{t('message.participationRate')}}</h4>
        <div class="wr">
          <div class="check-group ty02 mo-none">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.lineFrequencyRate"
                        @click.stop="onClickUpdateDisplay('lineFrequencyRate',reportDisplayInfo.lineFrequencyRate)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <Select v-bind="periodSelect" v-model="frequencyRatePeriodModel"/>
        </div>
      </div>
      <!--그래프 위치-->
      <div class="graph-group">
        <Line :data="frequencyRateLineData" :options="options_line" />
      </div>
    </div>
    <!--row-->
    <div class="content-inner-box ty01">
      <div class="tit-group ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineBehaviorRate=='Y')">
        <h4 class="tit">{{t('message.safetyBehaviorRate')}}</h4>
        <div class="wr">
          <div class="check-group ty02 mo-none">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.lineBehaviorRate"
                        @click.stop="onClickUpdateDisplay('lineBehaviorRate',reportDisplayInfo.lineBehaviorRate)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <Select v-bind="periodSelect" v-model="behaviorRatePeriodModel"/>
        </div>
      </div>
      <!--그래프 위치-->
      <div class="graph-group" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineBehaviorRate=='Y')">
        <Line :data="behaviorRateLineData" :options="options_line" />
      </div>
      <div class="cont-row" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.barBehaviorRate=='Y')">
        <div class="tit-group ty01">
          <h4 class="tit02">{{t('message.safetyBehaviorRateByCategory')}}</h4>
          <div class="wr">
            <div class="check-group ty02 mo-none">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.barBehaviorRate"
                          @click.stop="onClickUpdateDisplay('barBehaviorRate',reportDisplayInfo.barBehaviorRate)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="graph-group">
          <div class="graph-txt">
            <div class="txt"
                 v-for="(item, i) in behaviorStep1BarData.labelsObj"
                 :key="i">
              <button @click="apiReportBehaviorRate('behavior', item.categoryIdx, '')">{{item.label}}</button>
            </div>
          </div>
          <div class="graph-cont">
            <Bar :key="chartKey(1)" :data="behaviorStep1BarData" :options="options_bar1" ref="behaviorStep1Bar"/>
          </div>
        </div>
      </div>
      <div class="cont-row" v-if="behaviorStep2BarData.labelsObj">
        <div class="tit-group ty01">
          <h4 class="tit02">
            {{t('message.safetyBehaviorRateByObservationItem')}}
            <span class="sub-txt">
              {{t('message.clickObservationItemToViewDetails')}}
            </span>
          </h4>
          <div class="wr">
            <div class="check-group ty02 mo-none">
              <v-checkbox :label="t('message.isVisible')"></v-checkbox>
            </div>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="graph-group">
          <div class="graph-txt">
            <div class="txt"
                 v-for="(item, i) in behaviorStep2BarData.labelsObj"
                 :key="i">
              <button @click="apiReportBehaviorRate('comment', item.categoryIdx, item.behaviorIdx)">{{item.label}}</button>
            </div>
          </div>
          <div class="graph-cont">
            <Bar :key="chartKey(2)" :data="behaviorStep2BarData" :options="options_bar2" ref="behaviorStep2Bar"/>
          </div>
        </div>
      </div>
      <div class="cont-row" v-if="behaviorStep3BarData.labelsObj">
        <div class="tit-group ty01">
          <h4 class="tit02">
            {{t('message.safetyBehaviorRateByDetailedObservationItem')}}
          </h4>
          <div class="wr">
            <div class="check-group ty02 mo-none">
              <v-checkbox :label="t('message.isVisible')"></v-checkbox>
            </div>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="graph-group">
          <div class="graph-txt">
            <div class="txt"
                 v-for="(item, i) in behaviorStep3BarData.labelsObj"
                 :key="i">
              <button>{{item.label}}</button>
            </div>
          </div>
          <div class="graph-cont">
            <Bar :key="chartKey(3)" :data="behaviorStep3BarData" :options="options_bar" />
          </div>
        </div>
      </div>
    </div>
    <!--row-->
    <div class="content-inner-box ty01">
      <div class="tit-group ty01" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineTimelineRate=='Y')">
        <h4 class="tit">{{t('message.safetyTalkImplementationRate')}}
          <c-tooltip :TooltipText="t('message.whyAllResultsAre100Percent')"/>
        </h4>
        <div class="wr">
          <div class="check-group ty02 mo-none">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.lineTimelineRate"
                        @click.stop="onClickUpdateDisplay('lineTimelineRate',reportDisplayInfo.lineTimelineRate)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <Select v-bind="periodSelect" v-model="timelineRatePeriodModel"/>
        </div>
      </div>
      <!--그래프 위치-->
      <div class="graph-group" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.lineTimelineRate=='Y')">
        <Line :data="timelineRateLineData" :options="options_line" />
      </div>
      <div class="cont-row mo-none" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.listTimelineBehavior=='Y')">
        <div class="tit-group ty01">
          <h4 class="tit">{{t('message.safetyTalkActivityDetails')}}</h4>
          <div class="wr">
            <div class="check-group ty02">
              <v-checkbox :label="t('message.isVisible')"
                          v-if="user.roles != 'USER'"
                          v-model="reportDisplayInfo.listTimelineBehavior"
                          @click.stop="onClickUpdateDisplay('listTimelineBehavior',reportDisplayInfo.listTimelineBehavior)"
                          true-value="Y" false-value="N"></v-checkbox>
            </div>
            <c-btnLine01 :btnText="t('message.download')" @click="onClickDownload('t')" v-if="user.roles != 'USER'"/>
          </div>
        </div>
        <!--그래프 위치-->
        <div class="tbl-group size-custom14">
          <v-data-table
            :headers="headers"
            :items="timelineBehaviorItems"
            return-object
          >
            <template v-slot:item.action="{ item }" >
              <div class="ell01">
                {{item.action}}
              </div>
            </template>
            <template v-slot:item.detailView="{ item }">
              <div class="flex-c">
                <BtnIcon class="btn-ico-search" @click="onClickTimelineBehaviorDialog(item.behaviorIdx)"/>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <!--row-->
    <div class="content-inner-box ty01 mo-none" v-if="user.roles != 'USER' || (user.roles == 'USER' && reportDisplayInfo.listMemberActivity=='Y')">
      <div class="tit-group ty01">
        <h4 class="tit">{{t('message.individualActivityDetails')}}
          <div class="sub-txt02">
            <div class="col">
              {{t('message.totalParticipationCount')}} <span>{{behaviorStep3Cnt}}{{t('message.countUnit')}}</span>
            </div>
            <div class="line"></div>
            <div class="col">
              {{t('message.totalParticipationRate')}} <span>{{ behaviorStep3Rate }}%</span>
            </div>
          </div>
        </h4>
        <div class="wr">
          <div class="check-group ty02">
            <v-checkbox :label="t('message.isVisible')"
                        v-if="user.roles != 'USER'"
                        v-model="reportDisplayInfo.listMemberActivity"
                        @click.stop="onClickUpdateDisplay('listMemberActivity',reportDisplayInfo.listMemberActivity)"
                        true-value="Y" false-value="N"></v-checkbox>
          </div>
          <c-btnLine01 :btnText="t('message.download')" @click="onClickDownload('a')" v-if="user.roles != 'USER'"/>
        </div>
      </div>
      <!--그래프 위치-->
      <div class="tbl-group size-custom15">
        <v-data-table
          :headers="headers2"
          :items="memberActivityItems"
          return-object
        >
          <template v-slot:item.author="{ item }" >
            <div class="ell01">
              {{item.author}}
            </div>
          </template>
          <template v-slot:item.detailView="{ item }">
            <div class="flex-c">
              <BtnIcon class="btn-ico-search" @click="onClickMemberActivityDialog(item.memberIdx)"/>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
  </div>
  <MtDialog01 v-model="timelineBehaviorDialogModel" @close="timelineBehaviorDialogModel=false"/>
  <MtDialog02 v-model="memberActivityDialogModel" @close="memberActivityDialogModel=false"/>
  <MtDialog03 v-model="reportValidationDialogModel" @close="confirmValidation" @confirm="confirmValidation"/>
  <v-snackbar v-model="snackbar" :timeout="3000" location="center" class="custom-snackbar"> {{ snackText }} </v-snackbar>
</template>

<script setup lang="ts">
import {computed, onMounted, ref, watch} from 'vue';
import BbsService from "@/services/bbs.service";
import utils from "@/common/Utils";
import {useCommonStore} from "@/store/common";
import {storeToRefs} from "pinia";
import _ from 'lodash';
import dayjs from "dayjs";
import quarterOfYear from "dayjs/plugin/quarterOfYear"
import { Chart as ChartJS, Title, Tooltip, Legend, BarElement, PointElement, LineElement, CategoryScale, LinearScale } from 'chart.js'
import { Line, Bar } from 'vue-chartjs'
import ChartDataLabels from 'chartjs-plugin-datalabels';
import * as XLSX from 'xlsx'
import { useI18n } from 'vue-i18n';
import TimelineService from "@/services/timeline.service";
const { t } = useI18n();

//plugin
dayjs.extend(quarterOfYear)
ChartJS.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale, PointElement, LineElement, ChartDataLabels)

//store
const store = useCommonStore()
const storeRef = storeToRefs(store)
const route:any = useRoute()

//define
const props = defineProps({isActive: Boolean})

//bind
const snackbar = ref(false)
const snackText = ref('')
let viewIdx = route.params.idx ?? storeRef.viewIdx.value
const timelineBehaviorDialogModel = ref(false)
const memberActivityDialogModel = ref(false)
const reportValidationDialogModel = ref(false)
const startDate = ref('')
const endDate = ref('')
const memberModel = ref('m')
const deptModel = ref('')
const posModel = ref('')
const shiftModel = ref('')
const monitoringModel = ref<number>(0);
const monitoringInfo:any = ref({})
const reportDisplayInfo:any = ref({})
const periodAnswerCnt = ref(0)
const allAnswerCnt = ref(0)
const allPeriodCnt = ref(0)
const periodAnswerPercent = ref(0)
const allAnswerPercent = ref(0)
const timelineTy1Cnt = ref(0)
const timelineTy1CompleteCnt = ref(0)
const timelineTy1Percent = ref(0)
const timelineAllRate = ref(0)
const timelineTy1Rate = ref(0)
const timelineTy2Rate = ref(0)
const timelineAllAnswerCnt = ref(0)
const timelineTy1AnswerCnt = ref(0)
const timelineTy2AnswerCnt = ref(0)
const myTimelineTy1Cnt = ref(0)
const myTimelineTy2Cnt = ref(0)
const memberAnswerList = ref([])
const memberAnswerListReverse = ref([])
const frequencyRatePeriodModel = ref('week')
const behaviorRatePeriodModel = ref('week')
const timelineRatePeriodModel = ref('week')
const timelineBehaviorItems:any = ref([])
const memberActivityItems:any = ref([])
const frequencyRateLineData:any = ref({labels: [], datasets: []})
const behaviorRateLineData:any = ref({labels: [], datasets: []})
const timelineRateLineData:any = ref({labels: [], datasets: []})
const behaviorStep1BarData:any = ref({labels: [], datasets: []})
const behaviorStep1Bar:any = ref<HTMLInputElement | null>(null)
const behaviorStep2BarData:any = ref({labels: [], datasets: []})
const behaviorStep2Bar:any = ref<HTMLInputElement | null>(null)
const behaviorStep3BarData:any = ref({labels: [], datasets: []})
const behaviorStep3Cnt = ref(0)
const behaviorStep3Rate = ref(0)
let searchParams:any = {}
const user = ref(JSON.parse(localStorage.getItem('user')))

//ui
const memberSelect = computed(() =>( {items: [{name:t('message.individualViewUnit'), value:'m'},{name:t('message.departmentViewUnit'), value:'c'}]} ))
const deptSelectAdd = ref([])
const deptSelect = computed(() =>( {items: [{name:t('message.department'), value:''}, ...deptSelectAdd.value]} ))
const posSelectAdd = ref([])
const posSelect = computed(() =>( {items: [{name:t('message.position'), value:''}, ...posSelectAdd.value]} ))
const shiftSelect = ref( {items: [{name: t('message.shiftWork'), value: ''},{name: 'Y', value: 'Y'},{name: 'N', value: 'N'}]} )
const monitoringSelectAdd = ref([])
const monitoringSelect = computed(() =>( {items: [{name:t('message.monitoring'), value:''}, ...monitoringSelectAdd.value]} ))
const periodSelect = computed(() =>(  {items: [{name:t('message.week'), value:'week'},{name:t('message.month'), value:'month'}]} ))

//ui
const headers = ref([

  { title: t('message.behavior'), key: 'action' },
  { title: t('message.safetyTalk'), key: 'safetyTalk' },
  { title: t('message.praiseTalk'), key: 'cheerTalk' },
  { title: t('message.detailedContent'), key: 'detailView' },
])
const headers2 = ref([

  { title: t('message.author'), key: 'author' },
  { title: t('message.monitoring'), key: 'monitoring' },
  { title: t('message.safetyTalk'), key: 'safetyTalk' },
  { title: t('message.lastSubmissionDate'), key: 'submit' },
  { title: t('message.detailedContent'), key: 'detailView' },
])
const options_line:any = {
  responsive: true,
  maintainAspectRatio: false,
  layout: {
    padding: {
      top: 30
    }
  },
  clip: false,
  scales: {
    x: {
      title: {
        display: true,
        text: ''
      }
    },
    y: {
      title: {
        display: true,
        text: ''
      },
      min: 0,
      max: 100,
      ticks: {
        stepSize: 20
      },
      display:false
    },
  },
  plugins: {
    legend: {
      usePointStyle: true,
      position: 'bottom'
    },
    tooltip: {
      enabled: true,
      callbacks: {
        label: function (context) {
          const value = context.parsed.y; // y축 값
          return `${value}%`; // 뒤에 % 붙이기
        }
      }
    },
    datalabels: {
      anchor: 'center',  // 텍스트 위치 (start, center, end)
      align: 'top',   // 정렬 (top, bottom, middle)
      formatter: (value) => `${value}%`, // 데이터 값 표시
      font: {
        weight: 'bold'
      }
    }
  }
}
const options_bar:any = {
  indexAxis: 'y',
  barThickness:20,
  responsive: true,
  maintainAspectRatio: false,//뷰포트가 달라지면 원래의 비율을 유지한 채 늘어난다.반응형인 경우 아래 옵션을 추가하면 비율이 아닌 부모의 크기에 맞춰 늘어나고 줄어든다.
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        // forces step size to be 50 units
        stepSize: 20
      }
    },
    y:{
      display:false
    }
  },
  plugins: {
    legend: {
      display:false,
      usePointStyle: true,
      position: 'bottom'
    },
    callbacks: {
      label: function (context) {
        const value = context.parsed.x; // y축 값
        const answerCnt = behaviorStep3BarData.value.labelsObj.at(context.dataIndex).answerCnt
        return `${answerCnt}(${value}%)`; // 뒤에 % 붙이기
      }
    },
    datalabels: {
      anchor: 'center',   // 막대 내부 중앙
      align: 'center',    // 세로/가로 모두 중앙 정렬
      color: '#fff',      // 흰색 글씨
      formatter: (value) => `${value}%`,
      font: {
        weight: 'bold',
        size: 12
      }
    }
  }
}
const options_bar1:any = {
  indexAxis: 'y',
  barThickness:20,
  responsive: true,
  maintainAspectRatio: false,//뷰포트가 달라지면 원래의 비율을 유지한 채 늘어난다.반응형인 경우 아래 옵션을 추가하면 비율이 아닌 부모의 크기에 맞춰 늘어나고 줄어든다.
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        // forces step size to be 50 units
        stepSize: 20
      }
    },
    y:{
      display:false
    }
  },
  plugins: {
    legend: {
      display:false,
      usePointStyle: true,
      position: 'bottom'
    },
    callbacks: {
      label: function (context) {
        const value = context.parsed.x; // y축 값
        return `${value}%`; // 뒤에 % 붙이기
      }
    },
    datalabels: {
      anchor: 'center',   // 막대 내부 중앙
      align: 'center',    // 세로/가로 모두 중앙 정렬
      color: '#fff',      // 흰색 글씨
      formatter: (value) => `${value}%`,
      font: {
        weight: 'bold',
        size: 12
      }
    }
  },
  onClick: (e) => {
    const chart = behaviorStep1Bar.value.chart;
    const event = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false)
    const categoryIdx = behaviorStep1BarData.value.labelsObj.at(event.at(0).index).categoryIdx
    apiReportBehaviorRate('behavior', categoryIdx, '')
  }
}
const options_bar2:any = {
  indexAxis: 'y',
  barThickness:20,
  responsive: true,
  maintainAspectRatio: false,//뷰포트가 달라지면 원래의 비율을 유지한 채 늘어난다.반응형인 경우 아래 옵션을 추가하면 비율이 아닌 부모의 크기에 맞춰 늘어나고 줄어든다.
  scales: {
    x: {
      min: 0,
      max: 100,
      ticks: {
        // forces step size to be 50 units
        stepSize: 20
      }
    },
    y:{
      display:false
    }
  },
  plugins: {
    legend: {
      display:false,
      usePointStyle: true,
      position: 'bottom'
    },
    callbacks: {
      label: function (context) {
        const value = context.parsed.x; // y축 값
        return `${value}%`; // 뒤에 % 붙이기
      }
    },
    datalabels: {
      anchor: 'center',   // 막대 내부 중앙
      align: 'center',    // 세로/가로 모두 중앙 정렬
      color: '#fff',      // 흰색 글씨
      formatter: (value) => `${value}%`,
      font: {
        weight: 'bold',
        size: 12
      }
    }
  },
  onClick: (e) => {
    const chart = behaviorStep2Bar.value.chart;
    const event = chart.getElementsAtEventForMode(e, 'nearest', { intersect: true }, false)
    const categoryIdx = behaviorStep2BarData.value.labelsObj.at(event.at(0).index).categoryIdx
    const behaviorIdx = behaviorStep2BarData.value.labelsObj.at(event.at(0).index).behaviorIdx
    apiReportBehaviorRate('comment', categoryIdx, behaviorIdx)
  }
}

//hook
onMounted(() => {
})

//computed
const chartKey = computed(()=>(param) => {
  if(param==1)
    return JSON.stringify(behaviorStep1BarData.value)
  else if(param==2)
    return JSON.stringify(behaviorStep2BarData.value)
  else
    return JSON.stringify(behaviorStep3BarData.value)
})

//function
const apiReportSummary=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:deptModel.value?'':(memberModel.value=='m'?user.memberIdx:''),
    deptIdx:deptModel.value?deptModel.value:(memberModel.value=='c'?user.deptIdx:''),
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    monitoringIdx:monitoringModel.value,
    isExclude:'N',
    companyIdx:localStorage.getItem('companyIdx')
  }
  //summary
  BbsService.getBbsReportSummary(params).then(
    (response) => {
      periodAnswerCnt.value = response.result.periodAnswerCnt
      allAnswerCnt.value = response.result.allAnswerCnt
      allPeriodCnt.value = response.result.allPeriodCnt
      periodAnswerPercent.value = response.result.periodAnswerPercent
      allAnswerPercent.value = response.result.allAnswerPercent
      timelineTy1Cnt.value = response.result.timelineTy1Cnt //시정조치 횟수
      timelineTy1CompleteCnt.value = response.result.timelineTy1CompleteCnt //시정조치 완료 횟수
      timelineTy1Percent.value = response.result.timelineTy1Percent
      timelineAllRate.value = response.result.timelineAllRate //응답대비 안전대화 실시율
      timelineTy1Rate.value = response.result.timelineTy1Rate //응답대비 교정적 안전대화 실시율
      timelineTy2Rate.value = response.result.timelineTy2Rate //응답대비 지지적 안전대화 실시율
      timelineAllAnswerCnt.value = response.result.timelineAllAnswerCnt //응답대비 안전대화 실시 횟수
      timelineTy1AnswerCnt.value = response.result.timelineTy1AnswerCnt //응답대비 교정적 안전대화 실시 횟수
      timelineTy2AnswerCnt.value = response.result.timelineTy2AnswerCnt //응답대비 지지적 안전대화 실시 횟수
      myTimelineTy1Cnt.value = response.result.myTimelineTy1Cnt
      myTimelineTy2Cnt.value = response.result.myTimelineTy2Cnt
      memberAnswerList.value = response.result.memberAnswerList
      _.forEach(memberAnswerList.value, (val, key)=>{
        val.activityCnt = val.allAnswerCnt+val.timelineTy1Cnt+val.timelineTy2Cnt
      })
      memberAnswerList.value = _.sortBy(memberAnswerList.value, 'activityCnt')
      memberAnswerListReverse.value = _.sortBy(memberAnswerList.value, 'activityCnt').reverse()
      memberAnswerList.value = _.slice(memberAnswerList.value, 0, 3)
      memberAnswerListReverse.value = _.slice(memberAnswerListReverse.value, 0, 3)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiReportRate=(type)=>{
  let typeParam = frequencyRatePeriodModel.value
  if(type == 'behavior')
    typeParam = behaviorRatePeriodModel.value
  else if(type == 'timeline')
    typeParam = timelineRatePeriodModel.value
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:deptModel.value?'':(memberModel.value=='m'?user.memberIdx:''),
    deptIdx:deptModel.value?deptModel.value:(memberModel.value=='c'?user.deptIdx:''),
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    periodRateType:typeParam,
    isExclude:'N',
    companyIdx:localStorage.getItem('companyIdx')
  }
  //참여율정보
  BbsService.getBbsReportRate(params).then(
    (response) => {
      if(type == '' || type == 'frequency'){
        let labels = []
        let normalData = []
        let auditData = []
        _.forEach(response.result, (val, key)=>{
          labels.push(val.answerDate)
          normalData.push(val.answerPercentNormal)
          auditData.push(val.answerPercentAudit)
        })
        frequencyRateLineData.value = {
          labels: labels,
          datasets: [
            {
              label: t('message.participationRate'),
              borderColor: '#3C50E0',
              backgroundColor: '#3C50E0',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: normalData,
            },
            {
              label: t('message.auditParticipationRate'),
              borderColor: '#A155B9',
              backgroundColor: '#A155B9',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: auditData
            }
          ]
        }
      }
      if(type == '' || type == 'behavior'){
        let labels = []
        let normalData = []
        let auditData = []
        _.forEach(response.result, (val, key)=>{
          labels.push(val.answerDate)
          normalData.push(val.scoreNormal)
          auditData.push(val.scoreAudit)
        })
        behaviorRateLineData.value = {
          labels: labels,
          datasets: [
            {
              label: t('message.safetyBehaviorRate'),
              borderColor: '#3C50E0',
              backgroundColor: '#3C50E0',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: normalData,
            },
            {
              label: t('message.auditSafetyBehaviorRate'),
              borderColor: '#A155B9',
              backgroundColor: '#A155B9',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: auditData
            }
          ]
        }
      }
      if(type == '' || type == 'timeline'){
        let labels = []
        let normalData = []
        let auditData = []
        _.forEach(response.result, (val, key)=>{
          labels.push(val.answerDate)
          normalData.push(val.timelinePercentNormal)
          auditData.push(val.timelinePercentAudit)
        })
        timelineRateLineData.value = {
          labels: labels,
          datasets: [
            {
              label: t('message.safetyTalkImplementationRate'),
              borderColor: '#3C50E0',
              backgroundColor: '#3C50E0',
              borderWidth:2,
              pointBorderWidth:3,
              pointHoverBorderWidth:5,
              data: normalData
            }
          ]
        }
      }
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiReportBehaviorRate=(type, idx, idx2)=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:deptModel.value?'':(memberModel.value=='m'?user.memberIdx:''),
    deptIdx:deptModel.value?deptModel.value:(memberModel.value=='c'?user.deptIdx:''),
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    rateType:type,
    categoryIdx:idx,
    behaviorIdx:idx2,
    isExclude:'N',
    companyIdx:localStorage.getItem('companyIdx'),
    monitoringIdx:monitoringModel.value,
  }

  //bbs 리포트 카테고리별 통계 (카테고리별,관찰항목별,세부관찰항목별)
  BbsService.getMonitoringStepRate(params).then(
    (response) => {
      let labels = []
      let labelsObj = []
      let normalData = []
      _.forEach(response.result, (val, key)=>{
        if(type == 'category') {
          labels.push(val.categoryTitle?val.categoryTitle:'NA')
          labelsObj.push({categoryIdx:val.categoryIdx, label:val.categoryTitle?val.categoryTitle:'NA'})
        }
        else if(type == 'behavior') {
          labels.push(val.behaviorTitle)
          labelsObj.push({categoryIdx:val.categoryIdx, behaviorIdx:val.behaviorIdx, label:val.behaviorTitle})
        }
        if(type == 'comment') {
          labels.push(val.commentTitle)
          labelsObj.push({commentIdx:val.commentIdx, answerCnt:val.answerCnt, label:val.commentTitle})
        }
        normalData.push(val.score)
      })
      let barData = {
        labels: labels,
        datasets: [
          {
            label: t('message.safetyBehaviorRate'),
            backgroundColor: '#3C50E0',
            data: normalData
          }
        ],
        labelsObj:labelsObj
      }
      if(type == 'category') {
        behaviorStep1BarData.value = barData
        behaviorStep2BarData.value = {}
        behaviorStep3BarData.value = {}
      }
      else if(type == 'behavior') {
        behaviorStep2BarData.value = barData
        behaviorStep3BarData.value = {}
      }
      else if(type == 'comment')
        behaviorStep3BarData.value = barData
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiTimelineBehaviorList=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:deptModel.value?'':(memberModel.value=='m'?user.memberIdx:''),
    deptIdx:deptModel.value?deptModel.value:(memberModel.value=='c'?user.deptIdx:''),
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    isExclude:'N',
    companyIdx:localStorage.getItem('companyIdx')
  }
  searchParams = params
  //bbs 리포트 안전대화 활동상세
  BbsService.getMonitoringTimelineBehaviorCnt(params).then(
    (response) => {
      let tempItems = []
      _.forEach(response.result, (val, key)=>{
        tempItems.push({action:val.behaviorTitle, safetyTalk:val.timelineTy1Cnt, cheerTalk:val.timelineTy2Cnt, behaviorIdx:val.behaviorIdx})
      })
      timelineBehaviorItems.value = tempItems
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

const apiTimelineMemberList=()=>{
  const user = JSON.parse(localStorage.getItem('user'))
  let params = {
    startDate:startDate.value,
    endDate:endDate.value,
    memberIdx:deptModel.value?'':(memberModel.value=='m'?user.memberIdx:''),
    deptIdx:deptModel.value?deptModel.value:(memberModel.value=='c'?user.deptIdx:''),
    posIdx:posModel.value,
    shiftIdx:shiftModel.value,
    idx:monitoringModel.value,
    isExclude:'N',
    companyIdx:localStorage.getItem('companyIdx')
  }
  searchParams = params
  //bbs 리포트 개인별 활동상세
  BbsService.getMonitoringAnswerMemberCnt(params).then(
    (response) => {
      let tempItems = []
      let tempAnswerCnt = 0
      let tempPeriodCnt = 0
      _.forEach(response.result, (val, key)=>{
        tempItems.push({
          author:`${val.memberName||t('message.noInfo')}(${val.memberId||t('message.noInfo')}) / ${val.posName||t('message.noInfo')} / ${val.deptName||t('message.noInfo')}`,
          monitoring:val.answerCnt,
          safetyTalk:val.timelineCnt,
          submit:val.regDate,
          memberIdx:val.memberIdx
        })
        tempAnswerCnt += val.answerCnt
        tempPeriodCnt += val.periodCnt
      })
      memberActivityItems.value = tempItems
      behaviorStep3Cnt.value = tempAnswerCnt
      if(tempAnswerCnt == 0 || tempPeriodCnt == 0)
        behaviorStep3Rate.value = 0
      else
        behaviorStep3Rate.value = Math.round(tempAnswerCnt / tempPeriodCnt * 100)
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

//레포트 노출정보
const apiMonitoringReportDisplay=()=> {
  const companyIdx = localStorage.getItem('companyIdx')
  BbsService.getMonitoringReportDisplay({companyIdx: companyIdx}).then(
    (response) => {
      //모니터링 노출여부
      reportDisplayInfo.value = response.result
    },
    (error) => {
      if (error.status == 403)
        utils.movePage('/login')
      else {
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}
const onClickTimelineBehaviorDialog=(idx)=>{
  const user = JSON.parse(localStorage.getItem('user'))
  searchParams.behaviorIdx = idx
  searchParams.memberIdx = memberModel.value=='m'?user.memberIdx:'',
  storeRef.popupParams.value = searchParams
  timelineBehaviorDialogModel.value = true
}

const onClickMemberActivityDialog=(idx)=>{
  searchParams.memberIdx = idx
  storeRef.popupParams.value = searchParams
  memberActivityDialogModel.value=true
}

const onClickDate=(type)=>{
  let end = dayjs().endOf('month').format('YYYY-MM-DD')
  let start = dayjs().startOf('month').format('YYYY-MM-DD')
  if(type == 'quarter') {
    end = dayjs().endOf('quarter').format('YYYY-MM-DD')
    start = dayjs().startOf('quarter').format('YYYY-MM-DD')
  }
  else if(type == 'year') {
    end = dayjs().endOf('year').format('YYYY-MM-DD')
    start = dayjs().startOf('year').format('YYYY-MM-DD')
  }

  startDate.value = start.toString()
  endDate.value = end.toString()
}

//리포트 오브젝트 노출여부 설정
const onClickUpdateDisplay=(type, value)=>{
  //레포트 노출정보
  let companyIdx = localStorage.getItem('companyIdx')
  let params = {companyIdx:companyIdx}
  params[type] = value=='Y'?'N':'Y'
  BbsService.updateMonitoringReportDisplay(params).then(
    (response) => {
      //모니터링 노출여부
      reportDisplayInfo.value = response.result
    },
    (error) => {
      if(error.status == 403)
        utils.movePage('/login')
      else{
        snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
        snackbar.value = true
      }
    }
  )
}

//엑셀다운로드 타임라인
const getTimelineListExcel = async()=>{
  const user:any = JSON.parse(localStorage.getItem('user'))
  const params = _.cloneDeep(searchParams)
  params.memberIdx = memberModel.value=='m'?user.memberIdx:''
  params.idx = null
  params.delYn = 'N'
  params.isTemp = 'N'

  try{
    const response = await TimelineService.getTimelineList(params)
    if(response.success)
      return response.result
    else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//엑셀다운로드 행동리스트
const getBehaviorListExcel = async()=>{
  const user:any = JSON.parse(localStorage.getItem('user'))
  const params = _.cloneDeep(searchParams)
  params.memberIdx = memberModel.value=='m'?user.memberIdx:''
  params.idx = null
  params.delYn = 'N'
  params.isTemp = 'N'

  try{
    const response:any = await BbsService.getBehaviorListExcel(params)
    if(response.success)
      return response.result
    else{
      snackText.value = response.message
      snackbar.value = true
    }
  }
  catch(error){
    if(error.status == 403)
      utils.movePage('/login')
    else{
      snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
      snackbar.value = true
    }
  }
}

//{{t('message.filter')}} 메뉴 열고 닫기
const filterDiv1 = ref('off')
const filterOpen1=()=>{
  if(filterDiv1.value == 'off')
    filterDiv1.value = 'on'
  else
    filterDiv1.value = 'off'
}

//유효성검사 리프래쉬
const confirmValidation=()=>{
  refresh()
}

const onClickDownload=async(type)=>{
  let clientName = localStorage.getItem('clientName')
  let companyName = localStorage.getItem('companyName')

  let excelData:any = null
  let mappingFormat:any = null
  let fileName = null
  if(type == 'a') {
    let tempList = await getBehaviorListExcel()
    // 그룹화
    const grouped = _.groupBy(tempList, 'answerRowIdx');
    // 헤더 row 추가 및 결과 구성
    const groupedList = _(grouped)
      .toPairs()
      .flatMap(([rowIdx, items]) => {
        const headerRow = {
          ...items[0],
          commentIdx: 0,
        }

        let rows = [headerRow, ...items]

        // 사용자 입력 기타의견 row 추가
        if(items[0].commentEtc && items[0].commentEtc.trim() !== '' && items[0].selectedCommentIdx == 0){
          rows.push({
            ...items[0],
            commentIdx: -1,        // 기타의견 구분용
            commentTitle: `기타(${items[0].commentEtc})`
          })
        }

        return rows
      })
      .value();

    excelData = JSON.parse(JSON.stringify(groupedList))
    mappingFormat = mappingActivity
    fileName = 'rowDataList.xlsx'
    let preIdx = 0
    let preRowIdx = 0
    let number1 = 0
    let number2 = 0
    _.forEach(excelData, (item)=>{
      if(preRowIdx != item.answerRowIdx){
        if(preIdx != item.answerIdx)
          number1 = 1
        else
          number1++
        number2 = 0
        preIdx = item.answerIdx
        preRowIdx = item.answerRowIdx
      }

      let safeYn = ''
      if(item.etcYn == 'Y') safeYn = t('message.notApplicable')
      else if(item.answerData == '1' && item.commentIdx == 0) safeYn = t('message.safe') //안전
      else if(item.answerData == '0' && item.commentIdx == 0) safeYn = t('message.unsafe') //불안전
      else if((item.selectedCommentIdx == item.commentIdx && item.selectedCommentIdx != 0) || item.commentIdx == -1) safeYn = t('message.select') //선택 (기타 케이스 추가 : commentIdx-1)
      else if(item.selectedCommentIdx != item.commentIdx) safeYn = t('message.notSelected') //미선택

      let score = ''
      if(item.etcYn == 'Y') score = '-'
      else if(item.answerData == '1' && (item.commentIdx == 0)) score = '100%'
      else if(item.answerData == '1' && item.commentIdx != 0) score = '-'
      else if(item.answerData == '0' && (item.commentIdx == 0)) score = '0%'
      else if(item.answerData == '0' && (item.commentIdx != 0)) score = '-'

      item.regDate = dayjs(item.regDate).format('YYYY-MM-DD HH:mm') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD HH:mm')
      item.companyName = item.clientName
      item.groupName = item.companyName
      item.placeName = utils.isEmpty(item.place) ? t('message.noInfo') : item.place
      item.posName = utils.isEmpty(item.posName) ? t('message.noInfo') : item.posName
      item.deptName = utils.isEmpty(item.deptName) ? t('message.noInfo') : item.deptName
      item.memberName = utils.isEmpty(item.memberName) ? t('message.noInfo') : item.memberName
      item.order = item.commentIdx == 0 ? number1 : number1 + '-' + number2
      item.behaviorTitle = item.commentIdx == 0 ? item.behaviorTitle : item.commentTitle
      item.safeYn = safeYn
      item.score = score
      item.timelineYn = item.timelineIdx != 0 ? 'O' : 'X'

      number2++
    })
  }
  else if(type == 't'){ //데이터 정제
    let tempList = await getTimelineListExcel()
    excelData = JSON.parse(JSON.stringify(tempList))
    mappingFormat = mappingTimeline
    fileName = 'timelineList.xlsx'

    _.forEach(excelData, (item)=>{
      item.regDate = dayjs(item.regDate).format('YYYY-MM-DD HH:mm') == 'Invalid Date' ? '' : dayjs(item.regDate).format('YYYY-MM-DD HH:mm')
      //회사명
      item.companyName = clientName
      //그룹명
      item.groupName = companyName
      //직책(or정보없음)
      item.posName = utils.isEmpty(item.posName) ? t('message.noInfo') : item.posName
      //부서(or정보없음)
      item.deptName = utils.isEmpty(item.deptName) ? t('message.noInfo') : item.deptName
      //이름(or정보없음)
      item.memberName = utils.isEmpty(item.memberName) ? t('message.noInfo') : item.memberName
      //조치기한(or정보없음)
      item.goalDate = utils.isEmpty(item.goalDate) ? t('message.noInfo') : item.goalDate
      //시정조치여부, 교정+시정필요:필요, 교정+시정불필요:불필요, 지지:대상 아님
      item.actionYn = item.type=='2'? t('message.notTarget') : item.actionYn == 'Y' ? t('message.necessary') : t('message.notNecessary')
      //대상자상세  1:별도지정없음 2:부서명(or정보없음) 3:멤버명(or정보없음)
      item.targetName = item.targetType == '1' ? t('message.noInfo') : item.targetType == '2' ? utils.isEmpty(item.targetDeptName) ? t('message.noInfo') : item.targetDeptName : utils.isEmpty(item.targetMemberName) ? t('message.noInfo') : item.targetMemberName
      //대상자 1:별도지정없음 2:부서 3:멤버
      item.targetType = item.targetType == '1' ? t('message.noSpecificDesignation') : item.targetType == '2' ? t('message.department') : t('message.members')
      //행동명(or정보없음)
      item.behaviorTitle = utils.isEmpty(item.behaviorTitle) ? t('message.noInfo') : item.behaviorTitle
      //장소(or정보없음)
      item.placeName = utils.isEmpty(item.placeName) ? t('message.noInfo') : item.placeName
      //구체적상황(or공백)
      item.situation = item.situation
      //원인(or공백)
      item.cause = item.type == '1' ? item.cause : ''
      //시정조치(or공백)
      item.action = item.type == '1' ? item.action : ''
      //타입
      item.type = item.type == '1' ? t('message.corrective') : t('message.supportive')
    })
  }
  if(excelData.length == 0){
    snackText.value = t('message.noDataSelected')
    snackbar.value = true
    return
  }

  const dataWS = XLSX.utils.json_to_sheet(utils.renameKeys(mappingFormat, excelData))
  //const dataWS = XLSX.utils.json_to_sheet(excelData)
  const wb = XLSX.utils.book_new()
  XLSX.utils.book_append_sheet(wb, dataWS, 'Sheet1')
  XLSX.writeFile(wb, fileName)
}

/** 엑셀 다운로드 시 키값 rename */
const mappingTimeline = {
  regDate:t('message.registrationDate'),  //등록일
  companyName:t('message.companyName'),  //그룹명
  groupName:t('message.groupName'),  //회사명
  deptName:t('message.department'), //부서
  posName:t('message.position'), //직책
  memberName:t('message.name'), //이름
  monitoringTitle:t('message.monitoringName'), //모니터링이름
  type:t('message.type'), //타입
  actionYn:t('message.correctiveActionRequired'), //시정조치여부
  targetType:t('message.targetPerson'), //대상자
  targetName:t('message.targetPersonDetail'), //대상자 상세
  goalDate:t('message.actionDeadlineInBoard'), //조치기한
  behaviorTitle:t('message.behaviorName'), //행동명
  placeName:t('message.place'), //장소
  situation:t('message.specificSituation'), //구체적상황
  cause:t('message.cause'), //원인
  action:t('message.actionFeedbackContent'), //시정조치/칭찬 내용
}

const mappingActivity = {
  regDate:t('message.registrationDate'),  //등록일
  companyName:t('message.companyName'),  //그룹명
  groupName:t('message.groupName'),  //회사명
  deptName:t('message.department'), //부서
  posName:t('message.position'), //직책
  memberName:t('message.name'), //이름
  placeName:t('message.place'), //장소
  order:t('message.order'), //순서
  behaviorTitle:t('message.behaviorName'), //행동명
  safeYn:t('message.safe')+'/'+t('message.unsafe'), //안전,불안전
  score:t('message.safetyBehaviorRate'), //안전행동률
  timelineYn:t('message.isSafetyTalk'), //안전대화여부
}

const onClickInitFilter=()=>{
  onClickDate('month')
  memberModel.value = 'm'
  deptModel.value = ''
  posModel.value = ''
  shiftModel.value = ''
  monitoringModel.value = Number(viewIdx)
}

const refresh=()=>{
  apiReportSummary()
  apiReportRate('')
  apiReportBehaviorRate('category','','')
  setTimeout(()=>{apiReportBehaviorRate('behavior', '', '')}, 500)
  apiTimelineBehaviorList()
  apiTimelineMemberList()
}

//watch
watch(startDate, (newObj) => {
  if(props.isActive) {
    refresh()
  }
})
watch(endDate, (newObj) => {
  if(props.isActive){
    refresh()
  }
})
watch(deptModel, (newObj) => {
  if(props.isActive){
    refresh()
  }
})
watch(posModel, (newObj) => {
  if(props.isActive){
    refresh()
  }
})
watch(memberModel, (newObj) => {
  if(props.isActive){
    refresh()
  }
})
watch(shiftModel, (newObj) => {
  if(props.isActive){
    refresh()
  }
})
watch(monitoringModel, (newObj) => {
  if(props.isActive){
    refresh()
  }
})
watch(frequencyRatePeriodModel, (newObj) => {
  if(props.isActive)
    apiReportRate('frequency')
})
watch(behaviorRatePeriodModel, (newObj) => {
  if(props.isActive)
    apiReportRate('behavior')
})
watch(timelineRatePeriodModel, (newObj) => {
  if(props.isActive)
    apiReportRate('timeline')
})

watch(() => props.isActive, (val, oldVal) => {
  if (val) {
    if(viewIdx) {
      let params = {
        idx: viewIdx
      }
      //모니터링정보
      BbsService.getBbsMonitoring(params).then(
        (response) => {
          //모니터링
          monitoringInfo.value = response.result
        },
        (error) => {
          if(error.status == 403)
            utils.movePage('/login')
          else{
            snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
            snackbar.value = true
          }
        }
      )
    }
    //본인부서에 해당하는 모니터링, 부서, 맴버정보
    const companyIdx = localStorage.getItem('companyIdx')
    let params2 = {companyIdx: companyIdx, actionType:'1'}
    BbsService.getMonitoringFilter(params2).then(
      (response) => {
        //모니터링{{t('message.filter')}}
        let monitoringList = response.result.monitoringList
        monitoringSelectAdd.value = []
        _.forEach(monitoringList, (item)=>{
          monitoringSelectAdd.value.push({name:item.monitoringTitle, value:item.idx})
          if(viewIdx == item.idx)
            monitoringModel.value = item.idx
        })
        //부서{{t('message.filter')}}
        let deptList = response.result.deptList
        deptSelectAdd.value = []
        _.forEach(deptList, (item)=>{
          deptSelectAdd.value.push({name:item.treeName, value:item.idx})
        })
        //직책{{t('message.filter')}}
        let posList = response.result.posList
        posSelectAdd.value = []
        _.forEach(posList, (item)=>{
          posSelectAdd.value.push({name:item.treeName, value:item.idx})
        })
        //맴버{{t('message.filter')}}
        /*
        let memberList = response.result.memberList
      _.forEach(memberList, (item)=>{
          memberSelect.value.items.push({name:item.memberName, value:item.idx})
        })
         */
        let shiftArr = {items: [{name: t('message.shiftWork'), value: ''}]}
        response.result.shiftList.forEach((item)=>{
          shiftArr.items.push({name:item.shiftName, value:item.idx})
        })
        shiftSelect.value = shiftArr
      },
      (error) => {
        if(error.status == 403)
          utils.movePage('/login')
        else{
          snackText.value = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
          snackbar.value = true
        }
      }
    )

    apiMonitoringReportDisplay()
    onClickDate('month')
    refresh()
  }
},{ immediate: true })
</script>


<style lang="scss" >
</style>
